import { ConfigValue } from '@/core';

const environments: Environment[] = [
  {
    hostnames: [
      'localhost',
    ],
    config: {
      'VUE_APP_VERSION': process.env.VUE_APP_VERSION || "1.0.0",
      'VUE_APP_API': process.env.VUE_APP_API || 'api.test.maison365.com',
      // 'VUE_APP_API': process.env.VUE_APP_API || 'api.maison365.com',
      'VUE_APP_API_HTTPS': process.env.VUE_APP_API_HTTPS || true,
      'VUE_APP_HOSTNAME': process.env.VUE_APP_HOSTNAME || 'api.test.maison365.com',
      // 'VUE_APP_HOSTNAME': process.env.VUE_APP_HOSTNAME || 'api.maison365.com',
      'VUE_APP_API_VERSION': process.env.VUE_APP_API_VERSION || '/v1',
      'VUE_APP_LOCAL_STORAGE_TOKEN': process.env.VUE_APP_LOCAL_STORAGE_TOKEN || 'com.atabix.vue-spa_',
      'VUE_APP_BUGSNAG_RELEASE_STAGE': process.env.VUE_APP_BUGSNAG_RELEASE_STAGE || 'production',
      'NODE_ENV': '',
      'VUE_APP_PUSHER_KEY': '',
      'VUE_APP_PUSHER_CLUSTER': '',
      'VUE_APP_PUSHER_ENCRYPTED': '',
      'VUE_APP_MONDAY_API_VERSION': '/v1',
      'VUE_APP_MONDAY_API_KEY': '',
      'VUE_APP_MONDAY_BOARD_ID': '',
      'VUE_APP_MONDAY_BUGTRACKER_USER': '',
      'VUE_APP_MONDAY_GROUP_NAME': '',
      'VUE_APP_TIMEULAR_API_VERSION': '/v2',
    },
  },
  {
    hostnames: [
      'test-app.maison365.com',
    ],
    config: {
      'VUE_APP_VERSION': "1.0.0",
      'VUE_APP_API': 'api.test.maison365.com',
      'VUE_APP_API_HTTPS': true,
      'VUE_APP_HOSTNAME': 'api.test.maison365.com',
      'VUE_APP_API_VERSION': '/v1',
      'VUE_APP_LOCAL_STORAGE_TOKEN': 'com.atabix.vue-spa_',
      'VUE_APP_BUGSNAG_RELEASE_STAGE': 'production',
      'NODE_ENV': '',
      'VUE_APP_PUSHER_KEY': '',
      'VUE_APP_PUSHER_CLUSTER': '',
      'VUE_APP_PUSHER_ENCRYPTED': '',
      'VUE_APP_MONDAY_API_VERSION': '/v1',
      'VUE_APP_MONDAY_API_KEY': '',
      'VUE_APP_MONDAY_BOARD_ID': '',
      'VUE_APP_MONDAY_BUGTRACKER_USER': '',
      'VUE_APP_MONDAY_GROUP_NAME': '',
      'VUE_APP_TIMEULAR_API_VERSION': '/v2',
    },
  },{
    hostnames: [
      'test.maison365.com',
    ],
    config: {
      'VUE_APP_VERSION': "1.0.0",
      'VUE_APP_API': 'api.test.maison365.com',
      'VUE_APP_API_HTTPS': true,
      'VUE_APP_HOSTNAME': 'api.test.maison365.com',
      'VUE_APP_API_VERSION': '/v1',
      'VUE_APP_LOCAL_STORAGE_TOKEN': 'com.atabix.vue-spa_',
      'VUE_APP_BUGSNAG_RELEASE_STAGE': 'staging',
      'NODE_ENV': '',
      'VUE_APP_PUSHER_KEY': '',
      'VUE_APP_PUSHER_CLUSTER': '',
      'VUE_APP_PUSHER_ENCRYPTED': '',
      'VUE_APP_MONDAY_API_VERSION': '/v1',
      'VUE_APP_MONDAY_API_KEY': '',
      'VUE_APP_MONDAY_BOARD_ID': '',
      'VUE_APP_MONDAY_BUGTRACKER_USER': '',
      'VUE_APP_MONDAY_GROUP_NAME': '',
      'VUE_APP_TIMEULAR_API_VERSION': '/v2',
    },
  },
  {
    hostnames: [
      'stijlquiz.maison365.com',
      'sara.maison365.com',
    ],
    config: {
      'VUE_APP_VERSION': "1.0.0",
      'VUE_APP_API': 'api.maison365.com',
      'VUE_APP_API_HTTPS': true,
      'VUE_APP_HOSTNAME': 'api.maison365.com',
      'VUE_APP_API_VERSION': '/v1',
      'VUE_APP_LOCAL_STORAGE_TOKEN': 'com.atabix.vue-spa_',
      'VUE_APP_BUGSNAG_RELEASE_STAGE': 'production',
      'VUE_APP_PUSHER_KEY': '',
      'VUE_APP_PUSHER_CLUSTER': '',
      'VUE_APP_PUSHER_ENCRYPTED': '',
      'VUE_APP_MONDAY_API_VERSION': '/v1',
      'VUE_APP_MONDAY_API_KEY': '',
      'VUE_APP_MONDAY_BOARD_ID': '',
      'VUE_APP_MONDAY_BUGTRACKER_USER': '',
      'VUE_APP_MONDAY_GROUP_NAME': '',
      'VUE_APP_TIMEULAR_API_VERSION': '/v2',
    },
  },
];

export default environments;

export interface Environment {
  hostnames: string[];
  config: { [key: string]: ConfigValue };
}
